/* eslint-disable prefer-promise-reject-errors */
import React, { useContext } from 'react';
import { AuthContext } from 'store/context';
import { Form, Input, Alert } from 'antd';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { useWindowSize } from 'react-use';
import classNames from 'classnames';
import queryString from 'query-string';
import { resetPasswordUser } from 'store/actions/AuthAction';
import { MIN_MD } from 'constants/ThemeSetting';
import OmiButton from 'components/@Omini/OmiButton';
import BranchIntro from 'components/Auth/BranchIntro';

export default function ResetPassword() {
  const {
    AuthState: { loading, error },
    AuthDispatch,
  } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const formBtnSumitClasses = classNames({
    'omi-auth-form-submit': true,
    'mt-10 md:mt-16': !error,
  });
  const alertClasses = classNames({
    'omi-auth-alert': true,
    'flex items-center mt-8 md:mt-12': error,
    hidden: !error,
  });
  const handleSubmit = values => {
    const parsed = queryString.parse(location.search);
    resetPasswordUser({
      payload: { ...values, uid: parsed.uid || null, token: parsed.token || null },
      dispatch: AuthDispatch,
      navigate,
    });
  };
  return (
    <div className="flex flex-col lg:flex-row lg:h-auto">
      <div className="omi-auth-layout-title">
        <BranchIntro />
      </div>
      <div className="omi-auth-layout-content">
        <div className="flex lg:h-auto flex-col justify-start items-center m-6 mt-0 lg:justify-start lg:p-0">
          <div className="omi-auth-form forgot-done-container">
            <p className="omi-auth-form-title">Cập nhật lại mật khẩu</p>
            <p className="mb-6 lg:mb-8">
              Vui lòng nhập email tài khoản của bạn, chúng tôi sẽ gửi link xác nhận tới email.
            </p>
            <Form
              onFinish={handleSubmit}
              name="forgot-password"
              size={width >= MIN_MD ? 'large' : 'small'}
              layout="vertical"
            >
              {/* <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "Định dạng email không đúng. Vui lòng kiểm tra lại."
                  },
                  {
                    required: true,
                    message: "Yêu cầu nhập email."
                  }
                ]}
              >
                <Input placeholder="hello@omini.com" />
              </Form.Item> */}

              <Form.Item
                label="Mật khẩu mới"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Yêu cầu nhập mật khẩu.',
                  },
                ]}
              >
                <Input.Password
                  iconRender={visible =>
                    visible ? <EyeFilled width={18} height={18} /> : <EyeInvisibleFilled width={18} height={18} />
                  }
                  placeholder="Nhập mật khẩu"
                />
              </Form.Item>
              <Form.Item
                label="Nhập lại mật khẩu"
                name="password_confirmation"
                dependencies={['password']}
                rules={[
                  {
                    required: true,
                    message: 'Yêu cầu nhập lại mật khẩu.',
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject('Mật khẩu không trùng khớp. Vui lòng nhập lại mật khẩu.');
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="b-radius-8 text-grey-700 f-semibold "
                  iconRender={visible =>
                    visible ? <EyeFilled width={18} height={18} /> : <EyeInvisibleFilled width={18} height={18} />
                  }
                  placeholder="Nhập lại mật khẩu"
                />
              </Form.Item>
              <Form.Item className={formBtnSumitClasses}>
                <Alert className={alertClasses} message={error} type="error" showIcon />
                <OmiButton type="primary" htmlType="submit" block loading={loading}>
                  Cập nhật
                </OmiButton>
              </Form.Item>
              <div className="flex justify-end mt-4">
                <Link to="/login" className="f-semibold text-grey-700 text-xs sm:text-sm sm:mb-8">
                  Trở về đăng nhập
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
